export default __webpack_public_path__ + "static/media/linkedin.bdd0cc4b.svg";